/**
 * True when the current page is running inside a Tauri webview.
 * Used by shared UI to choose desktop-specific visibility and material
 * behavior. MasterLayout owns steady-state desktop chrome; DesktopShell
 * only provides native runtime hooks and a pre-mount compact fallback.
 *
 * Tauri injects `__TAURI_INTERNALS__` onto window before any user
 * code runs, so the check is cheap and synchronous.
 */
export function isTauri(): boolean {
  return typeof window !== "undefined" && "__TAURI_INTERNALS__" in window;
}
